import { Card, CardColors, Text } from '@/ui'
import { getFetchError } from '@/reducers/fetch'
import { useReselector } from '@/utils/sharedHooks'
import { TextColors, TypographyStyles } from '@/styles'
export const CurrentInfoCard = ({
  headerText,
  subheader,
  bottomLeftText,
  bottomRightText,
  insightsFetchKey,
}: {
  headerText?: string | number
  subheader?: string | number
  bottomLeftText?: string | number
  bottomRightText?: string | number
  insightsFetchKey: string
}) => {
  const insightsSummaryError = useReselector(getFetchError, insightsFetchKey)

  if (insightsSummaryError) {
    return (
      <Card color={CardColors.LEVEL_1} className="w-full min-h-[160px] my-0">
        <Text variant={TypographyStyles.H2} className="mb-2">
          $ -
        </Text>
        <Text variant={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
          Something went wrong - please try again in a bit.
        </Text>
      </Card>
    )
  }
  return (
    <Card
      color={CardColors.LEVEL_1}
      className="w-full h-full min-h-[160px] my-0"
      childrenClassName="flex flex-col h-full"
    >
      <Text
        variant={TypographyStyles.DISPLAY_MD}
        className="mb-0 whitespace-nowrap"
        color={TextColors.BRAND}
      >
        {headerText}
      </Text>
      <Text
        variant={TypographyStyles.LABEL_SM}
        color={TextColors.MUTED}
        className="mb-4"
      >
        {subheader}
      </Text>

      {/* Bottom row */}
      <div className="mt-auto flex flex-col sm:flex-row justify-between">
        <Text
          className="text-left"
          variant={TypographyStyles.BODY_XS}
          color={TextColors.MUTED}
        >
          {bottomLeftText}
        </Text>
        <Text
          className="text-right"
          variant={TypographyStyles.LABEL_XS}
          color={TextColors.MUTED}
        >
          {bottomRightText}
        </Text>
      </div>
    </Card>
  )
}
